import { DOM, CLASSES } from '../_consts';
import Utility from '../helpers/_Utility';


export default class Modal {
  constructor() {
    this.modalLink = Array.prototype.slice.call(document.querySelectorAll('.js-modal-link'));
    this.modalEl = Array.prototype.slice.call(document.querySelectorAll('.js-modal'));
    this.modalCloseBtn = Array.prototype.slice.call(document.querySelectorAll('.js-close-modal'));
    this.modalSelector = '.js-modal';
    this.modalElLength = this.modalEl.length;
    this.bodyHiddenStatus = 0;
  }

  init() {
    if (this.modalElLength) {

      $(this.modalEl).on('click', '.js-close-modal', this.deactivateModal.bind(this));
      $(this.modalLink).on('click', this.openTrigger.bind(this));
      $(this.modalCloseBtn).on('click', this.deactivateAllModals.bind(this));
      this.active = true;
    } else {
      this.active = false;
    }
  }


  openTrigger(e) {
    e.preventDefault();
    const current = e.currentTarget;
    const targetAttr = $(current).attr('data-modal-target');
    const $target = $(`.js-modal[data-modal="${targetAttr}"]`);

    const isLeave = $(current).hasClass('js-modal-leave');

    this.open($target, isLeave);
  }

  deactivateModal(e) {
    e.preventDefault();
    const modal = e.target.closest(this.modalSelector);
    if (!modal) return;
    modal.classList.remove(CLASSES.isOpen);
    $(modal).fadeOut(200);
    $(modal).removeClass('is-faded');
    this.updateStatus();
  }

  deactivateAllModals(leave = false) {
    if (!leave) {
      this.modalEl.forEach(element => {
        $(element).fadeOut(150);
        $(element).removeClass('is-faded');
        $(element).removeClass(CLASSES.isOpen);
      });
    }
  }

  open(el, leave = false) {
    this.deactivateAllModals(leave);
    const timeoutClose = $(el).attr('data-timeout-close');

    $(el).fadeIn(200, () => {
      setTimeout(() => {
        $(el).addClass('is-faded');
      }, 400)
    });

    $(el).addClass(CLASSES.isOpen);

    if (!DOM.$body.hasClass(CLASSES.modalOpened)) {
      Utility.addBodyHidden();
    }

    if (timeoutClose) {
      setTimeout(() => {
        this.close(el)
      }, parseInt(timeoutClose, 10))
    }
  }

  updateStatus() {
    if (this.bodyHiddenStatus === 1) {
      this.bodyHiddenStatus = 0;
    } else {
      DOM.$body.removeClass(CLASSES.modalOpened);
      Utility.removeBodyHidden();
    }
  }

  close(el) {
    $(el).fadeOut(150);
    $(el).removeClass('is-faded');
    $(el).removeClass(CLASSES.isOpen);
    this.updateStatus();
  }
}
